import { PayloadAction } from '@reduxjs/toolkit';
import { handleResponseError, handleResponseMessage } from 'app/rootSaga';
import { AxiosError } from 'axios';
import { CommonResponse } from 'models';
import { call, put, takeLatest } from 'redux-saga/effects';
import barMenuService from './barMenuService';
import { barMenuListActions } from './barMenuSlice';
import { BarMenu, BarMenuSerializers } from './models/IBarMenu';

function* getListOfBarGuideInfoMenu(action: PayloadAction<number>) {
  try {
    const params = action.payload;
    const response: CommonResponse<Array<BarMenu>> = yield call(barMenuService.getBarMenuList, params);
    yield put(barMenuListActions.fetchListOfBarMenuSuccess(response));
  } catch (e) {
    yield put(barMenuListActions.fetchListOfBarMenuFailed());
    yield handleResponseError(e as AxiosError);
  }
}

function* deleteBarInfoMenu(action: PayloadAction<Array<number>>) {
  try {
    const params = action.payload;
    const response: CommonResponse<Array<BarMenu>> = yield call(barMenuService.deleteBarMenuList, params);
    yield put(barMenuListActions.deleteBarMenuSuccess(response));
    const resMessage: CommonResponse<null> = { ...response, data: null };
    yield handleResponseMessage(resMessage);
  } catch (e) {
    yield handleResponseError(e as AxiosError);
  }
}

function* addNewBarInfo(action: PayloadAction<Array<BarMenuSerializers>>) {
  try {
    const params = action.payload;
    const response: CommonResponse<Array<BarMenu>> = yield call(barMenuService.addNewBarMenu, params);
    yield put(barMenuListActions.addNewBarMenuSuccess(response));
    const resMessage: CommonResponse<null> = { ...response, data: null };
    yield handleResponseMessage(resMessage);
  } catch (e) {
    yield handleResponseError(e as AxiosError);
  }
}

export default function* barInfoListSaga() {
  yield takeLatest(barMenuListActions.fetchListOfBarMenu.type, getListOfBarGuideInfoMenu);
  yield takeLatest(barMenuListActions.deleteBarMenu.type, deleteBarInfoMenu);
  yield takeLatest(barMenuListActions.addNewBarMenu.type, addNewBarInfo);
}
